import DefaultPaymentCheckbox from 'components/RwdCheckout/Sections/Payment/Section/DefaultPaymentCheckbox/DefaultPaymentCheckbox';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { orderSelector } from 'selectors/order/orderSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import paymentsActions from 'actions/PaymentsActions';
import PaymentSectionEN from 'components/RwdCheckout/Sections/Payment/Section/locales/PaymentSection_en_US.js';
import PaymentSectionFR from 'components/RwdCheckout/Sections/Payment/Section/locales/PaymentSection_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(PaymentSectionEN, PaymentSectionFR);

const fields = createSelector(
    userSelector,
    orderSelector,
    (_state, ownProps) => ownProps.paymentName,
    (_state, ownProps) => ownProps.useSelectedDefaultOnly,
    createStructuredSelector({
        setAsDefaultPaymentLabel: getTextFromResource(getText, 'setAsDefaultPayment'),
        setAsDefaultPaymentNoticeLabel: getTextFromResource(getText, 'setAsDefaultPaymentNotice')
    }),
    (user, order, paymentName, useSelectedDefaultOnly, textResources) => {
        const selectedAsDefaultPaymentName = user.selectedAsDefaultPaymentName;
        const hasUserSelectedDefaultPayment = Boolean(selectedAsDefaultPaymentName);
        const savedAsDefaultInProfile =
            !useSelectedDefaultOnly && !hasUserSelectedDefaultPayment && order?.paymentOptions?.defaultPayment === paymentName;
        const checked = hasUserSelectedDefaultPayment
            ? selectedAsDefaultPaymentName === paymentName
            : useSelectedDefaultOnly
                ? false
                : savedAsDefaultInProfile;

        return {
            paymentName,
            checked,
            disabled: !useSelectedDefaultOnly && savedAsDefaultInProfile,
            ...textResources
        };
    }
);

const functions = {
    addDefaultPaymentToProfile: paymentsActions.addDefaultPaymentToProfile,
    removeDefaultPaymentFromProfile: paymentsActions.removeDefaultPaymentFromProfile
};

const withDefaultPaymentCheckboxProps = wrapHOC(connect(fields, functions));

export default withDefaultPaymentCheckboxProps(DefaultPaymentCheckbox);
